import ReactGA from 'react-ga4';

class GoogleAnalytics {
  public static readonly init = () => {
    ReactGA.initialize(process.env.REACT_APP_ANALYTICS_MC ?? '');
  };

  public static readonly writeLog = (
    action: string,
    category: string,
    label = ''
  ) => {
    ReactGA.event({
      category,
      action,
      label
    });
  };
}

export default GoogleAnalytics;
